<script context="module">
    import { get } from "svelte/store";

    import { apiMethods } from "../../../Services/index.svelte";

    import {
        getHHMM,
        isObjectEmpty,
    } from "../../../Utils/utilFunctions.svelte";
    import { mbsAllItemsList } from "../../../stores";
    import { cacheMbsItems } from "../../../Utils/utilCache.svelte";

    export const updateConsultItems = (
        item = {},
        selectedItems = [],
        type = "add",
        isCardiacEncounter,
    ) => {
        if (isObjectEmpty(item)) return selectedItems;

        let res = [...selectedItems];

        const { itemNum } = item;
        const requiredItemsCodes = [17615, 17620, 17625];
        const specialItemCodes = [17690];
        const specialItemAffectProcedures = [92701];
        const selectedConsults = res.filter(
            (item) => item.infoType == "Consults",
        );

        if (type.toLowerCase() == "delete") {
            if (isCardiacEncounter) res = removeCardiacItem(item, res);
            else if (!requiredItemsCodes.includes(itemNum))
                res = removeItem(item, res);
            else if (
                !selectedItems.some((itm) =>
                    specialItemCodes.includes(itm.itemNum),
                )
            )
                res = removeItem(item, res);
            else
                selectedItems.map((itm) => {
                    if (item.itemNum == itm.itemNum)
                        res = removeItem(item, res);
                    if (specialItemCodes.includes(itm.itemNum))
                        res = removeItem(itm, res);
                });
        } else if (isCardiacEncounter) {
            const targetItem = get(mbsAllItemsList).find(
                (item) => item.itemNum == itemNum,
            );

            if (!targetItem) return res;

            const cardiacHospitalContradictoryItems = [55130, 55135, 55118];

            const targetItemIsHospitalConsultItem =
                cardiacHospitalContradictoryItems.includes(targetItem.itemNum);
            const hasHospitalConsultItems = selectedItems.some((itm) =>
                cardiacHospitalContradictoryItems.includes(itm.itemNum),
            );

            // remove all hospital consult items before adding new one
            if (targetItemIsHospitalConsultItem && hasHospitalConsultItems)
                res = selectedItems.filter(
                    (itm) =>
                        !cardiacHospitalContradictoryItems.includes(
                            itm.itemNum,
                        ),
                );

            const { infoType } = targetItem;

            if (!selectedItems.length) res = addItem(targetItem, res);
            else if (!selectedItems.some((itm) => itm.itemNum == itemNum)) {
                if (infoType != "Consults") res = addItem(targetItem, res);
                else {
                    // Remove all consult items before adding new one
                    res = selectedItems.filter(
                        (itm) => itm.infoType != "Consults",
                    );
                    res = addItem(targetItem, res);
                }
            } else res = []; // Remove all items when consult type changes
        } else {
            if (!selectedConsults.length) res = addItem(item, res);
            else if (specialItemCodes.includes(itemNum)) {
                if (selectedConsults.some((item) => item.itemNum == itemNum))
                    res = removeItem(item, res);
                else res = addItem(item, res);
            } else if (requiredItemsCodes.includes(itemNum)) {
                if (
                    !selectedConsults.some((item) =>
                        specialItemCodes.includes(item.itemNum),
                    )
                ) {
                    selectedConsults.map((item) => {
                        res = removeItem(item, res);
                    });
                    res = addItem(item, res);
                } else {
                    selectedConsults.map((item) => {
                        if (!specialItemCodes.includes(item.itemNum))
                            res = removeItem(item, res);
                    });
                    res = addItem(item, res);
                }
            } else {
                selectedConsults.map((item) => (res = removeItem(item, res)));
                res = addItem(item, res);
            }

            if (specialItemAffectProcedures.includes(itemNum))
                res = res.filter(
                    (item) => item.infoType != "AdditionalProcedures",
                );
        }

        return res;
    };

    export const updateSurgeryItems = (
        item = {},
        selectedItems = [],
        itemProps = {},
        specialItems = [],
    ) => {
        if (isObjectEmpty(item)) return selectedItems;

        let res = [...selectedItems];

        const selectedSurgeryItems = res.filter(
            (item) => item.infoType == "Surgery",
        );

        if (!selectedSurgeryItems.length)
            res = addSurgeryItem(item, res, itemProps, specialItems);
        else if (selectedSurgeryItems[0].id == item.id)
            res = removeSurgeryItem(item, res);
        else {
            selectedSurgeryItems.map((item) => {
                res = removeSurgeryItem(item, res);
            });
            res = addSurgeryItem(item, res, itemProps, specialItems);
        }

        return res;
    };

    export const updateModifierItems = (item = {}, selectedItems = []) => {
        const { itemNum, infoRegion } = item;

        let res = [...selectedItems];

        const selectedASAItems = res.filter((item) => item.infoRegion == "ASA");
        const selectedEmergencyItems = res.filter(
            (item) => item.infoRegion == "Emergency",
        );

        if (infoRegion == "Emergency") {
            if (!selectedEmergencyItems.length) res = addItem(item, res);
            else {
                const selectedEmergencyItem = selectedEmergencyItems[0];
                if (itemNum == selectedEmergencyItem.itemNum)
                    res = removeItem(selectedEmergencyItem, res);
                else
                    res = addItem(item, removeItem(selectedEmergencyItem, res));
            }
        } else if (infoRegion == "ASA") {
            if (!selectedASAItems.length) res = addItem(item, res);
            else {
                const selectedAsaItem = selectedASAItems[0];
                if (itemNum == selectedAsaItem.itemNum)
                    res = removeItem(selectedAsaItem, res);
                else res = addItem(item, removeItem(selectedAsaItem, res));
            }
        } else if (infoRegion == "Age"){
            //can only be removed, added happens automatically on surgery selection
            const selectedAgeItem = selectedItems.find((i) => i.itemNum == itemNum);
            if (selectedAgeItem)
                res = removeItem(selectedAgeItem, res);
        }
        return res;
    };

    export const updateProcedureItems = (
        item = {},
        selectedItems = [],
        itemProps = {},
        defaultItems = [],
        holidaysInState = [],
        isFromSearch = false,
        openNotification = () => {},
    ) => {
        let res = [...selectedItems];

        if (itemProps.billingType != 2)
            res = updateProcedureItemWithoutTimeCheck(
                item,
                selectedItems,
                itemProps,
                defaultItems,
                openNotification,
            );
        else
            res = updateProcedureItemWithTimeCheck(
                item,
                selectedItems,
                itemProps,
                defaultItems,
                holidaysInState,
                isFromSearch,
            );

        return res;
    };

    export const updateTimeItems = (item = {}, selectedItems = []) => {
        if (isObjectEmpty(item)) return selectedItems;

        let res = [...selectedItems];

        const selectedTimeItem = res.filter((item) => item.infoType == "Time");

        if (!selectedTimeItem.length) res = addItem(item, res);
        else {
            selectedTimeItem.map((item) => {
                res = removeItem(item, res);
            });
            res = addItem(item, res);
        }

        return res;
    };

    export const updateNonCategoryItems = (item = {}, selectedItems = []) => {
        let res = [...selectedItems];

        const { itemNum, subItemNum } = item;

        if (
            selectedItems.some(
                (item) =>
                    item.itemNum == itemNum && item.subItemNum == subItemNum,
            )
        )
            res = removeItem(item, res);
        else res = addItem(item, res);

        return res;
    };

    const addItem = (item, arr) => {
        return [...arr, item];
    };

    const removeItem = (item, arr) => {
        return arr.filter((i) => i.id !== item.id);
    };

    const removeCardiacItem = (item, arr) => {
        return arr.filter((i) => i.itemNum !== item.itemNum);
    };

    const addSurgeryItem = (item, selectedItems, itemProps, specialItems) => {
        let res = [...selectedItems];

        const { patientAge } = itemProps;
        const specialItemCodes = [25013, 25014];
        const specialAgeItem =
            patientAge < 4
                ? specialItems.find(
                      (item) => item.itemNum == specialItemCodes[0],
                  )
                : patientAge >= 75
                  ? specialItems.find(
                        (item) => item.itemNum == specialItemCodes[1],
                    )
                  : {};
        const selectedTimeItems = res.filter((item) => item.infoType == "Time");

        res = addItem(item, res);

        if (!isObjectEmpty(specialAgeItem)) res = addItem(specialAgeItem, res);

        if (
            itemProps.itemType.toLowerCase() == "quote" &&
            !selectedTimeItems.length
        ) {
            const timeItem = specialItems.find((item) => item.itemNum == 23025);
            res = addItem(timeItem, res);
        } else if (
            itemProps.itemType.toLowerCase() == "invoice" &&
            itemProps.startDate &&
            itemProps.endDate
        ) {
            const targetTime = convertTimeRangeInMin(
                itemProps.startDate,
                itemProps.endDate,
            );
            const timeOptions = specialItems.filter(
                (item) => item.infoType == "Time",
            );
            const targetItem = getItemInTimeRange(targetTime, timeOptions);

            if (
                targetItem &&
                !selectedItems.some(
                    (item) => item.itemNum == targetItem.itemNum,
                )
            )
                res = addItem(targetItem, res);
        }

        return res;
    };

    const removeSurgeryItem = (item, selectedItems) => {
        let res = [...selectedItems];

        const specialItemCodes = [25013, 25014];

        res = removeItem(item, res);

        const specialItems = res.filter((item) =>
            specialItemCodes.includes(item.itemNum),
        );

        if (specialItems.length)
            specialItems.map((itm) => {
                res = removeItem(itm, res);
            });

        return res;
    };

    const getItemInTimeRange = (mins = Number(0), timeOptions = []) => {
        if (!mins)
            return timeOptions.find(
                (item) => item.infoShortTitle == "15 MINUTES OR LESS",
            );
        else {
            return timeOptions.find((item) => {
                const timeRange = convertTitleToMin(item.infoShortTitle);
                if (
                    Number(timeRange[0]) <= mins &&
                    Number(timeRange[1]) >= mins
                )
                    return item;
            });
        }
    };

    export const convertTimeRangeInMin = (start, end) => {
        const startTime = new Date(start);
        const endTime = new Date(end);

        return (endTime - startTime) / (1000 * 60);
    };

    export const convertTitleToMin = (title) => {
        title = title.toUpperCase();

        let min = Number(0),
            max = Number(0);

        if (title == "15 MINUTES OR LESS") max = Number(15);
        else if (title.includes("MINUTES")) {
            if (title.includes("TO")) {
                min = Number(
                    title.split("TO")[0].trim().replace("MINUTES", ""),
                );
                max = Number(
                    title.split("TO")[1].includes("MINUTES")
                        ? title.split("TO")[1].trim().replace("MINUTES", "")
                        : Number(
                              title
                                  .split("TO")[1]
                                  .trim()
                                  .replace("HOURS", "")
                                  .split(":")[0] * 60,
                          ),
                );
            } else if (title.includes("-")) {
                min = Number(title.split("-")[0].trim().replace("MINUTES", ""));
                max = Number(
                    title.split("-")[1].includes("MINUTES")
                        ? title.split("-")[1].trim().replace("MINUTES", "")
                        : Number(
                              title
                                  .split("-")[1]
                                  .trim()
                                  .replace("HOURS", "")
                                  .split(":")[0] * 60,
                          ),
                );
            }
        } else if (title.includes("HOURS")) {
            let minTime, maxTime;

            if (title.includes("TO")) {
                minTime = title.split("TO")[0].replace("HOURS", "");
                maxTime = title.split("TO")[1].replace("HOURS", "");
            } else if (title.includes("-")) {
                minTime = title.split("-")[0].trim().replace("HOURS", "");
                maxTime = title.split("-")[1].trim().replace("HOURS", "");
            }

            const minTimeArr = minTime.split(":");
            const maxTimeArr = maxTime.split(":");

            min = Number(minTimeArr[0]) * 60 + Number(minTimeArr[1]);
            max = Number(maxTimeArr[0]) * 60 + Number(maxTimeArr[1]);
        }

        return [min, max];
    };

    const updateProcedureItemWithoutTimeCheck = (
        item,
        selectedItems,
        itemProps,
        defaultItems,
        openNotification,
    ) => {
        let res = [...selectedItems];

        const specialItemsMap = new Map([
            ["22025-0", ["22012-0", "22014-0"]],
            ["22020-0", ["22012-1", "22014-1"]],
            ["22015-0", ["22012-2", "22014-2"]],
            ["regionalContradictoryItems", [18220, 18225]],
            ["topUpContradictoryItems", [22031, 22036]],
            ["toeContradictoryItems", [22051, 22054]],
            ["aliasItems", [22012, 22014]],
        ]);
        const regionalContradictoryItems = specialItemsMap.get(
            "regionalContradictoryItems",
        );
        const topUpContradictoryItems = specialItemsMap.get(
            "topUpContradictoryItems",
        );
        const toeContradictoryItems = specialItemsMap.get(
            "toeContradictoryItems",
        );
        const aliasItems = specialItemsMap.get("aliasItems");

        const { itemNum, subItemNum } = item;
        const combinedKey = `${itemNum}-${subItemNum}`;

        if (specialItemsMap.has(combinedKey)) {
            const aliasArr = specialItemsMap.get(combinedKey);

            res = updateProcedureWithAlias(
                combinedKey,
                aliasArr,
                itemProps,
                selectedItems,
                defaultItems,
                openNotification,
            );
        } else if (regionalContradictoryItems.includes(item.itemNum))
            res = updateProcedureWithContradictory(
                item,
                selectedItems,
                regionalContradictoryItems,
            );
        else if (topUpContradictoryItems.includes(item.itemNum))
            res = updateProcedureWithContradictory(
                item,
                selectedItems,
                topUpContradictoryItems,
            );
        else if (toeContradictoryItems.includes(item.itemNum))
            res = updateProcedureWithContradictory(
                item,
                selectedItems,
                toeContradictoryItems,
            );
        else if (aliasItems.includes(itemNum)) {
            res = updateProcedureAliasOnly(
                combinedKey,
                selectedItems,
                itemProps,
                defaultItems,
                openNotification,
            );
        } else if (
            selectedItems.some(
                (itm) =>
                    itm.itemNum == item.itemNum &&
                    itm.subItemNum == item.subItemNum,
            )
        )
            res = removeItem(item, res);
        else res = addItem(item, res);

        return res;
    };

    const updateProcedureWithAlias = (
        itemStr,
        aliasArr,
        itemProps,
        selectedItems,
        defaultItems,
        openNotification,
    ) => {
        let res = [...selectedItems];

        const { mbsItem22012UsedToday, mbsItem22014UsedToday } = itemProps;

        const itemDetails = itemStr.split("-");

        const item = defaultItems.find(
            (itm) =>
                itm.itemNum.toString() == itemDetails[0] &&
                itm.subItemNum.toString() == itemDetails[1],
        );

        const hasItemAlreadySelected = selectedItems.some(
            (itm) =>
                itm.itemNum == item.itemNum &&
                itm.subItemNum == item.subItemNum,
        );

        if (!res.length || !hasItemAlreadySelected) {
            res = addItem(item, res);
            if (mbsItem22012UsedToday && mbsItem22014UsedToday)
                openNotification();
        } else if (hasItemAlreadySelected) res = removeItem(item, res);

        if (mbsItem22012UsedToday && mbsItem22014UsedToday) {
            // remove added alias item if accidentally added before
            const selectedAliasItem = res.find(
                (itm) =>
                    (itm.itemNum == aliasArr[0].split("-")[0] &&
                        itm.subItemNum == aliasArr[0].split("-")[1]) ||
                    (itm.itemNum == aliasArr[1].split("-")[0] &&
                        itm.subItemNum == aliasArr[1].split("-")[1]),
            );

            if (selectedAliasItem) res = removeItem(selectedAliasItem, res);

            return res;
        }

        let aliasItemStr = "";

        if (!mbsItem22012UsedToday) aliasItemStr = aliasArr[0];
        else if (!mbsItem22014UsedToday) aliasItemStr = aliasArr[1];

        const aliasItemDetails = aliasItemStr.split("-");
        const aliasItem = defaultItems.find(
            (item) =>
                item.itemNum.toString() == aliasItemDetails[0] &&
                item.subItemNum.toString() == aliasItemDetails[1],
        );

        const hasAliasItemAlreadySelected = selectedItems.some(
            (itm) =>
                itm.itemNum == aliasItem.itemNum &&
                itm.subItemNum == aliasItem.subItemNum,
        );

        if (hasItemAlreadySelected && hasAliasItemAlreadySelected)
            res = removeItem(aliasItem, res);
        else if (!hasAliasItemAlreadySelected) res = addItem(aliasItem, res);

        return res;
    };

    const updateProcedureWithContradictory = (
        item = {},
        selectedItems = [],
        contradictoryArr = [],
    ) => {
        let res = [...selectedItems];

        const contradictoryItemNum = contradictoryArr.find(
            (itemNum) => item.itemNum != itemNum,
        );

        if (res.some((item) => item.itemNum == contradictoryItemNum)) {
            const replaceItem = res.find(
                (item) => item.itemNum == contradictoryItemNum,
            );
            res = removeItem(replaceItem, res);
            res = addItem(item, res);
        } else if (res.some((itm) => itm.itemNum == item.itemNum))
            res = removeItem(item, res);
        else res = addItem(item, res);

        return res;
    };

    const updateProcedureAliasOnly = (
        itemStr,
        selectedItems = [],
        itemProps,
        defaultItems,
        openNotification,
    ) => {
        let res = [...selectedItems];

        const { mbsItem22012UsedToday, mbsItem22014UsedToday } = itemProps;

        if (mbsItem22012UsedToday && mbsItem22014UsedToday) {
            openNotification();
            return res;
        }

        const itemDetails = itemStr.split("-");

        const item = defaultItems.find(
            (itm) =>
                itm.itemNum.toString() == itemDetails[0] &&
                itm.subItemNum.toString() == itemDetails[1],
        );

        // Add pair 22014 item with correct subItemNum if mbsItem22012UsedToday
        if (mbsItem22012UsedToday && item.itemNum.toString() == "22012") {
            if (mbsItem22014UsedToday) return res;

            const replaceItem = defaultItems.find(
                (itm) =>
                    itm.itemNum.toString() == "22014" &&
                    itm.subItemNum.toString() == itemDetails[1],
            );

            if (!replaceItem) return res;

            if (
                selectedItems.some(
                    (itm) =>
                        itm.itemNum.toString() ==
                            replaceItem.itemNum.toString() &&
                        itm.subItemNum.toString() ==
                            replaceItem.subItemNum.toString(),
                )
            )
                res = removeItem(replaceItem, res);
            else res = addItem(replaceItem, res);

            return res;
        }

        if (mbsItem22014UsedToday && item.itemNum.toString() == "22014")
            return res;

        const hasItemAlreadySelected = selectedItems.some(
            (itm) =>
                itm.itemNum == item.itemNum &&
                itm.subItemNum == item.subItemNum,
        );

        if (!res.length || !hasItemAlreadySelected) res = addItem(item, res);
        else if (hasItemAlreadySelected) res = removeItem(item, res);

        return res;
    };

    const updateProcedureItemWithTimeCheck = (
        item,
        selectedItems,
        itemProps,
        defaultItems,
        holidaysInState,
        isFromSearch,
    ) => {
        let res = [...selectedItems];

        const { startDate, endDate } = itemProps;

        if (!startDate || !endDate) return res;

        const specialItemsForOverHalf = [18216, 18219];
        const specialItemsForLessHalf = [18226, 18227];
        const specialItemsInKeyOne = [18216, 18226];
        const specialItemsInKeyTwo = [18222, 18225];

        if (isFromSearch) {
            const containsNeuraxialInsertion =
                specialItemsForOverHalf.includes(item.itemNum) ||
                specialItemsForLessHalf.includes(item.itemNum);
            const containsNeuraxialTopUp = specialItemsInKeyTwo.includes(
                item.itemNum,
            );
            if (containsNeuraxialInsertion && containsNeuraxialTopUp)
                itemProps.neuraxialType = 3;
            else if (containsNeuraxialInsertion) item = { ...item, key: 1 };
            else if (containsNeuraxialTopUp) item = { ...item, key: 2 };
        }

        const timeDiff = convertTimeRangeInMin(startDate, endDate);
        const overlapMins = getOverlapMins(
            startDate,
            endDate,
            holidaysInState,
            itemProps,
        );
        const overlapPercentage = Math.round((overlapMins / timeDiff) * 100);

        if (item?.key == 1) {
            // INSERTION
            if (timeDiff <= 60) {
                const targetItem =
                    overlapPercentage > 50
                        ? defaultItems.find(
                              (i) => i.itemNum == specialItemsInKeyOne[0],
                          )
                        : defaultItems.find(
                              (i) => i.itemNum == specialItemsInKeyOne[1],
                          );

                if (!targetItem) return res;

                targetItem.key = item.key;
                targetItem.encounterItemDescription = `${startDate.split("T")[1].slice(0, 5)} - ${endDate.split("T")[1].slice(0, 5)}`;

                //remove any additional procedure item if exists
                if (selectedItems.some((item) => item.infoType == "AdditionalProcedures")) {
                    selectedItems.map((item) => {
                        if (item.infoType == "AdditionalProcedures")
                            res = removeItem(item, res);
                    });
                }
               
                //add item back updated
                res = addItem(targetItem, res);
                
            } else {
                const targetItems =
                    overlapPercentage > 50
                        ? defaultItems.filter((i) =>
                              specialItemsForOverHalf.includes(i.itemNum),
                          )
                        : defaultItems.filter((i) =>
                              specialItemsForLessHalf.includes(i.itemNum),
                          );

                if (!targetItems.length) return res;


                const firstHourEndTime = getHHMM(
                    new Date(
                        new Date(startDate).setTime(
                            new Date(startDate).getTime() + 60 * 60 * 1000,
                        ),
                    ),
                );

                targetItems[0].encounterItemDescription = `${startDate.split("T")[1].slice(0, 5)} - ${firstHourEndTime}`;

                targetItems[1].encounterItemDescription = `${firstHourEndTime} - ${endDate.split("T")[1].slice(0, 5)}`;

                //remove any additional procedure item if exists
                if (selectedItems.some((item) => item.infoType == "AdditionalProcedures")) {
                    selectedItems.map((item) => {
                        if (item.infoType == "AdditionalProcedures")
                            res = removeItem(item, res);
                    });
                }

                //add items back updated
                res = addItem(targetItems[0], res);
                res = addItem(targetItems[1], res);
                
            }
        } else if (item?.key == 2) {
            // TOP UP
            const targetItem =
                timeDiff <= 15
                    ? defaultItems.find(
                          (i) => i.itemNum == specialItemsInKeyTwo[0],
                      )
                    : defaultItems.find(
                          (i) => i.itemNum == specialItemsInKeyTwo[1],
                      );

            //remove eisting item if exists
            if (selectedItems.some((item) => item.infoType == "AdditionalProcedures")) {
                selectedItems.map((item) => {
                    if (item.infoType == "AdditionalProcedures")
                        res = removeItem(item, res);
                });
            }

            //add item back updated
            res = addItem(targetItem, res);
        } 

        return res;
    };

    const getOverlapMins = (start, end, holidaysInState, itemProps) => {
        const workStartTime = new Date(start);
        const workEndTime = new Date(end);
        const startTime = new Date(start);
        const endTime = new Date(end);

        // normal operating hours 8am - 8pm, otherwise is after hours
        workStartTime.setHours(8, 0, 0, 0);
        workEndTime.setHours(20, 0, 0, 0);

        // all weekends are after hours
        const { scheduledDate } = itemProps;
        if (
            new Date(scheduledDate).getDay() == 0 ||
            new Date(scheduledDate).getDay() == 6
        )
            return 0;

        const startDate = start.split("T")[0] + "T00:00:00";

        // public holidays are after hours
        if (holidaysInState.some((holiday) => holiday.date == startDate))
            return 0;

        const maxStart = Math.max(startTime, workStartTime);
        const minEnd = Math.min(endTime, workEndTime);

        if (maxStart >= minEnd) return 0;

        return Math.round((minEnd - maxStart) / (1000 * 60));
    };

    export const fetchAndSyncItemsRebate = async (items = []) => {
        const itemNums = [];

        items.map(({ itemNum }) => itemNums.push(itemNum));

        await apiMethods.getMethod
            .getMBSItems(0, 999999, {
                "filter[itemNum]": itemNums.join(","),
            })
            .then((res) => {
                res.results.map((rItem) => {
                    const index = items.findIndex(
                        (item) =>
                            item.itemNum == rItem.itemNum &&
                            item.subItemNum == rItem.subItemNum,
                    );
                    items[index] = { ...items[index], ...rItem };
                });
            });

        return items;
    };

    export const searchMbsItems = async (searchText) => {
        if (!get(mbsAllItemsList).length) await cacheMbsItems();

        const allItems = get(mbsAllItemsList);

        searchText = searchText.toString().toLowerCase();

        return allItems.filter(
            (item) =>
                item.itemNum.toString().includes(searchText) ||
                item.infoShortTitle.toLowerCase().includes(searchText) ||
                item.infoRegion.toLowerCase().includes(searchText) ||
                item.infoSubRegion.toLowerCase().includes(searchText) ||
                item.description.toLowerCase().includes(searchText),
        );
    };

    export const getCardiacMbsCodes = () => [
        {
            itemNum: 17610,
            infoType: "Cardiac",
            infoRegion: "Anaesthesia",
            infoSubRegion: "Pre-anaesthesia consults",
            infoShortTitle: "<15 mins",
        },
        {
            itemNum: 17615,
            infoType: "Cardiac",
            infoRegion: "Anaesthesia",
            infoSubRegion: "Pre-anaesthesia consults",
            infoShortTitle: "16-30 mins",
        },
        {
            itemNum: 17620,
            infoType: "Cardiac",
            infoRegion: "Anaesthesia",
            infoSubRegion: "Pre-anaesthesia consults",
            infoShortTitle: "31-45 mins",
        },
        {
            itemNum: 17625,
            infoType: "Cardiac",
            infoRegion: "Anaesthesia",
            infoSubRegion: "Pre-anaesthesia consults",
            infoShortTitle: "46+ mins",
        },
        {
            itemNum: 22060,
            infoType: "Cardiac",
            infoRegion: "Perfusion",
            infoSubRegion: "",
            infoShortTitle: "Bypass",
        },
        {
            itemNum: 22055,
            infoType: "Cardiac",
            infoRegion: "ECMO",
            infoSubRegion: "",
            infoShortTitle: "ECMO",
        },
        {
            itemNum: 55130,
            infoType: "Cardiac",
            infoRegion: "TOE",
            infoSubRegion: "In hospital",
            infoShortTitle: "TOE Cardiac",
        },
        {
            itemNum: 55135,
            infoType: "Cardiac",
            infoRegion: "TOE",
            infoSubRegion: "In hospital",
            infoShortTitle: "TOE Valves",
        },
        {
            itemNum: 55118,
            infoType: "Cardiac",
            infoRegion: "TOE",
            infoSubRegion: "Outside hospital",
            infoShortTitle: "TOE",
        },
    ];

    export const hasCardiacMbsCode = (selectedItems = []) => {
        if (!selectedItems) return false;

        const cardiacConsultItems = getCardiacMbsCodes();

        return selectedItems.some((item) =>
            cardiacConsultItems.some((itm) => itm.itemNum == item.itemNum),
        );
    };

    export const getMbsItemNumLabel = (item) => {
        const { itemNum } = item;

        if (!itemNum) return "";

        return `${itemNum}:`;
    };
</script>
